import React, { useEffect, useState } from 'react';
import './Checkbox.css';

function Checkbox({ label, value, checked, onChange,name, id, errId, isDisabled }) {
  const [isChecked, setIsChecked] = useState(checked);

  useEffect(() => {
    if(value){
      setIsChecked(true);
    }else{
      setIsChecked(false);
    }
  },[value])

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
    if (onChange) {
      onChange(!isChecked, name, id, errId);
    }
  };

  return (
    <label className="checkbox-container">
      <input
        type="checkbox"
        className="checkbox-input"
        checked={isChecked}
        onChange={handleCheckboxChange}
        disabled={isDisabled}
      />
      <span className="checkbox-box"></span>
      <span className="label-text">{label}</span>
    </label>
  );
}

export default Checkbox;
